import React from 'react'
import { PageHeader, SurfaceCard } from '../../Components/Ui'
import ArticleForm from './ArticleForm'

const Article = () => {
    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Nuevo Blog"
            subtitle="Completa el formulario para publicar una nueva entrada."
        />
        <SurfaceCard>
            <ArticleForm />
        </SurfaceCard>
    </>
}

export default Article
